import {
  Image,
  Text,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerCloseButton,
  Flex,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Tab,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

export const AboutModal = ({ isOpen, onClose, room, imageUrl }) => {
  const guides = room?.propertyGuide || [];


  return (
    <Drawer placement="bottom" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent
        h="82vh"
        borderTopRadius="2xl"
        zIndex="1500"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        maxW={{ base: "100%", md: "680px" }}
        mx="auto"
        mb={{ md: 8 }}
        borderRadius={{ md: "24px" }}
      >
        <Flex mx={3} my={4} alignItems="center" justifyContent="space-between">
          <Text mr={4} fontSize="18px" fontWeight={800}>
            {room?.address &&
              JSON.parse(room.address)
                .formatted_address.split(",")
                .slice(0, -2)
                .join(",")}
          </Text>

          <DrawerCloseButton pos="relative" top={0} right={0} />
        </Flex>

        <Tabs
          variant="soft-rounded"
          isLazy
          height="100%"
          display="flex"
          flexDirection="column"
        >
          {/* Tabs should NOT scroll */}
          <TabList
            px={3}
            pb="12px"
            overflowX="auto"
            whiteSpace="nowrap"
            flexShrink={0}
          >
            <Tab
              fontSize="12px"
              color="gray.600"
              _selected={{ color: "white", bg: "#817EFF" }}
            >
              Description
            </Tab>
            {guides.map((section, index) => (
              <Tab
                key={index}
                fontSize="12px"
                color="gray.600"
                _selected={{ color: "white", bg: "#817EFF" }}
              >
                {section.description || `Section ${index + 1}`}
              </Tab>
            ))}
          </TabList>

          {/* Panels should scroll */}
          <Box overflowY="auto" px={0} flex="1" pb={"35px"}>
            <TabPanels>
              <TabPanel py={2} px={0} pb={"35px"}>
                <Image
                  pb={4}
                  objectFit="cover"
                  w="100%"
                  maxH="250px"
                  src={imageUrl || room?.images}
                  alt={room?.name}
                />
                <Text px={4}>{room?.description}</Text>
              </TabPanel>

              {guides.map((section, index) => (
                <TabPanel key={index} py={2} px={0} pb={"35px"}>
                  <Box
                    pb={"50px"}
                    className="ql-editor"
                    dangerouslySetInnerHTML={{ __html: section.text }}
                  />
                </TabPanel>
              ))}
            </TabPanels>
          </Box>
        </Tabs>
      </DrawerContent>
    </Drawer>
  );
};
